/** @format */

import { ChangeDetectionStrategy, Component, Signal, computed, inject, input } from '@angular/core';
import {
  CompareProductItem,
  HeaderStoreSelection,
  ProductAvailabilityCollection,
} from '@shared/data-access/interfaces';

import { CompareProductDetailsError } from '@compare/data-access';
import { ProductAvailabilityComponent } from '@shared/components';
import { SkeletonFulfillmentSectionComponent } from '../skeleton-fulfillment-section/skeleton-fulfillment-section.component';
import { Store } from '@ngrx/store';
import { WINDOW } from '@shared/data-access/services';
import { selectUserStoreInfo } from '@state/data-access';

@Component({
  selector: 'compare-components-fulfillment-section',
  imports: [SkeletonFulfillmentSectionComponent, ProductAvailabilityComponent],
  templateUrl: './fulfillment-section.component.html',
  styleUrl: './fulfillment-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FulfillmentSectionComponent {
  private readonly store = inject(Store);

  readonly productEcode = input.required<string>();
  readonly productDetailsData = input.required<CompareProductItem | null>();
  readonly compareProductsAvailability = input.required<ProductAvailabilityCollection | null>();

  readonly userStoreInfo = this.store.selectSignal<HeaderStoreSelection | null>(
    selectUserStoreInfo,
  );

  readonly isLoadingFulfillment = computed(() => {
    return !this.compareProductsAvailability()?.ecodeMessagingMap?.[this.productEcode()];
  });

  readonly isLoading = computed(() => !this.productDetailsData());

  readonly productErrors: Signal<CompareProductDetailsError[]> = computed(() =>
    this.checkForProductErrors(this.productDetailsData()),
  );

  private readonly window = inject<Window>(WINDOW);

  openStoreDrawer(): void {
    if (this.window?.headerFunctions?.storeSelection) {
      this.window.headerFunctions.storeSelection();
    } else {
      // eslint-disable-next-line no-console
      console.warn('Store selection function is not available in the current window context.');
    }
  }

  private checkForProductErrors(
    productDetailsData: CompareProductItem | null,
  ): CompareProductDetailsError[] {
    if (!productDetailsData) {
      return [];
    }

    const errors: CompareProductDetailsError[] = [];

    if (!productDetailsData.style) {
      errors.push('noStyle');
    }

    if (!productDetailsData.style?.prices) {
      errors.push('noPrices');
    }

    return errors;
  }
}
